module.exports = __webpack_public_path__ + "static/media/skeletonDeo.aa7a3d1e.gif";